import React from 'react'
import ConfirmUpload from '../Components/ConfirmUpload/ConfirmUpload'

const ConfirmUploadView = () => {
  return (
    <div>
        <ConfirmUpload />
    </div>
  )
}

export default ConfirmUploadView